'use client'

import React from 'react'
import Newsletter, { NewsletterProps } from 'components/commercetools-ui/organisms/newsletter'

interface Props {
  data: NewsletterProps;
}

const NewsletterTastic: React.FC<Props> = ({ data }) => <Newsletter {...data} />

export default NewsletterTastic
